import { z } from "zod";

export const SIGHTGLASS_RESEARCH_TASK_ID = "sightglass-research-company";

/** What the last research run left behind, stored on the company. */
export const sightglassResearchOutcomeSchema = z.enum([
  "collected",
  "no_ads",
  "failed",
]);

export type SightglassResearchOutcome = z.infer<
  typeof sightglassResearchOutcomeSchema
>;

/** Derived on read from the company's research timestamps; null means never researched. */
export const sightglassResearchStatusSchema = z.enum([
  "researching",
  "collected",
  "no_ads",
  "failed",
]);

export type SightglassResearchStatus = z.infer<
  typeof sightglassResearchStatusSchema
>;

export function researchStatusFor(company: {
  researchStartedAt: string | null;
  researchFinishedAt: string | null;
  researchOutcome: SightglassResearchOutcome | null;
}): SightglassResearchStatus | null {
  if (!company.researchStartedAt) {
    return null;
  }
  if (
    !company.researchFinishedAt ||
    Date.parse(company.researchFinishedAt) <
      Date.parse(company.researchStartedAt)
  ) {
    return "researching";
  }
  return company.researchOutcome;
}

/** Why an ad's link could not be followed to a landing page. Stored on the ad, never a URL or a body. */
export const sightglassDestinationFailureReasonSchema = z.enum([
  "invalid_url",
  "blocked_target",
  "redirect_loop",
  "redirect_limit",
  "missing_location",
  "dns",
  "request",
  "http_status",
  "timeout",
]);

export type SightglassDestinationFailureReason = z.infer<
  typeof sightglassDestinationFailureReasonSchema
>;
